<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="My Payroll Slip" />
    <!-- Container-fluid starts-->
    <div class="container-fluid" v-if="bank_details">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 20px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Search..."></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!payrollLoading && !payrollError">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                
                                    <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                      <template #cell(employee_name)="data">
                                        <div v-b-modal.modal-disbursement-view @click="viewDisburse(data.item)">
                                            <strong>
                                                {{ data.item?.employee?.full_name || '-' }}
                                            </strong>

                                            <br>

                                            <small>
                                                {{ data.item?.employee?.additional_info?.employee_id || '-' }}
                                            </small>

                                            <br>

                                             <div class="d-flex flex-wrap flex-row" style="gap: 6px;">
                                                <h7>
                                                    {{ data.item?.employee?.additional_info?.department?.name || '-' }}
                                                </h7>
                                                <h7>
                                                    | {{ data.item?.employee?.additional_info?.designation?.title || '-' }}
                                                </h7>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(pay_period)="data">
                                        <p v-if="data.item?.slip_data?.pay_period?.month">{{ getMonthName(data.item?.slip_data?.pay_period?.month) }}<span v-if="data.item?.slip_data?.pay_period?.year">, {{ data.item.slip_data.pay_period.year }}</span></p>
                                    </template>
                                    <template #cell(gross_salary)="data">
                                        {{ data.item.gross_salary }}
                                    </template>

                                    <template #cell(net_pay)="data">
                                        {{ data.item.net_pay }}
                                    </template>

                                    <template #cell(paid_amount)="data">
                                        {{ data.item.paid_amount }}
                                    </template>

                                    <template #cell(due_amount)="data">
                                        {{ data.item.due_amount }}
                                    </template>

                                    <template #cell(payment_status)="data">
                                        <span class="badge" :class="{
                                            'bg-success': data.item.payment_status === 'PAID',
                                            'bg-warning': data.item.payment_status === 'PARTIALLY_PAID',
                                            'bg-danger': data.item.payment_status === 'UNPAID'
                                            }">
                                            {{ data.item.payment_status.replaceAll('_', ' ') }}
                                        </span>
                                    </template>

                                    <template #cell(generated_on)="data">
                                        {{ new Date(data.item.generated_on).toLocaleDateString() }}
                                    </template>
                           
                                    <template #cell(toggle)="row">
                                        <b-button
                                            size="sm"
                                            variant="outline-primary"
                                            @click="row.toggleDetails"
                                        >
                                            {{ row.detailsShowing ? 'Hide' : 'Payments' }}
                                        </b-button>
                                    </template>


                                     <template #row-details="row">
        <div class="p-3 bg-light">
            <b-table
                small
                bordered
                hover
                show-empty
                :items="row.item.slip_data?.payments || []"
                :fields="paymentFields"
            >
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>

                <template #cell(disbursed_on)="data">
                    {{
                        data.item.disbursed_on
                            ? new Date(data.item.disbursed_on).toLocaleString()
                            : '-'
                    }}
                </template>

                <template #empty>
                    <div class="text-center">
                        No payment history found
                    </div>
                </template>
            </b-table>
        </div>
    </template>
                                    </b-table>
                                
                            </div>

                          
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body d-flex flex-column align-items-center" style="gap: 20px;">
                        <feather type="file-text" size="48px" style="color: #94a3b8;"></feather>
                        <h5 style="color: #64748b;">You need to add bank details to view your payroll slip.</h5>
                        <b-button variant="primary" @click="$router.push('/user/profile')">Add Bank Details</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal id="modal-disbursement-view" size="lg" title="Payroll Slip Details" hide-footer modal-class="payroll-modal">
        <div v-if="disbursement">
            <div class="row payroll-content">
                <!-- Employee Information -->
                <div class="col-md-6 mb-4">
                    <div class=" payroll-card">
                        <div class="payroll-card-header">
                            Employee Information
                        </div>

                        <div class="card-body payroll-card-body">
                            <p> <strong>Name:</strong> {{ disbursement?.employee?.full_name }} </p>
                            <p> <strong>Employee ID:</strong> {{ disbursement?.employee?.additional_info?.employee_id }} </p>
                            <p> <strong>Email:</strong> {{ disbursement?.employee?.email }} </p>
                            <p> <strong>Phone:</strong> {{ disbursement?.employee?.additional_info?.phone_number }} </p>
                            <p> <strong>Designation:</strong> {{ disbursement?.slip_data?.designation }} </p>
                            <p> <strong>Department:</strong> {{ disbursement?.slip_data?.department }} </p>
                        </div>
                    </div>
                </div>

                <!-- Bank Information -->
                <div class="col-md-6 mb-4">
                    <div class=" payroll-card">
                        <div class=" payroll-card-header">
                            Bank Information
                        </div>
                        <div class="card-body payroll-card-body">
                            <p> <strong>Bank:</strong> {{ disbursement?.slip_data?.bank_detail?.bank_name }} </p>
                            <p> <strong>Account Number:</strong> {{ disbursement?.slip_data?.bank_detail?.account_number }} </p>
                            <p> <strong>Routing Number:</strong> {{ disbursement?.slip_data?.bank_detail?.routing_number }} </p>
                        </div>
                    </div>
                </div>

                <!-- Inclusions -->
                <div class="col-md-6">
                    <div class=" payroll-card">
                        <div class=" payroll-card-header">
                            Inclusions
                        </div>

                        <div class="card-body payroll-card-body">
                            <table class="table payroll-table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th class="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in disbursement?.slip_data?.earnings" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td class="text-right"> ৳ {{ item.amount }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Deductions -->
                <div class="col-md-6">
                    <div class=" payroll-card">
                        <div class="payroll-card-header">
                            Deductions
                        </div>

                        <div class="card-body payroll-card-body">
                            <table class="table payroll-table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th class="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in disbursement?.slip_data?.deductions" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td class="text-right"> ৳ {{ item.amount }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Summary -->
                <div class="col-12 mt-4">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-gross">
                                <small>Gross Salary</small>
                                <h3>৳ {{ disbursement?.slip_data?.gross_salary }}</h3>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-net">
                                <small>Net Pay</small>
                                <h3>৳ {{ disbursement?.slip_data?.net_pay }}</h3>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-status">
                                <small>Authorised By</small>
                                <h5>
                                    {{
                            disbursement?.slip_data?.authorized_by
                                ? disbursement?.slip_data?.authorized_by
                                : 'N/A'
                        }}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    computed
} from 'vue';
import moment from 'moment';

export default {
    data() {
        return {
            filter: null,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'employee_name',
                    label: 'Employee'
                },
                {
                    key: 'pay_period',
                    label:'Pay Period'
                },
                {
                    key: 'gross_salary',
                    label: 'Gross Salary'
                },
                {
                    key: 'net_pay',
                    label: 'Net Pay'
                },
                {
                    key: 'paid_amount',
                    label: 'Paid Amount'
                },
                {
                    key: 'due_amount',
                    label: 'Due Amount'
                },
                {
                    key: 'toggle',
                    label: ''
                },
                {
                    key: 'payment_status',
                    label: 'Status'
                },
                {
                    key: 'generated_on',
                    label: 'Generated On'
                }

            ],
            paymentFields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'amount',
                    label: 'Amount'
                },
                {
                    key: 'disbursement_sheet',
                    label: 'Disbursement Sheet'
                },
                {
                    key: 'disbursed_on',
                    label: 'Disbursed On'
                },
                {
                    key: 'authorized_by',
                    label: 'Authorized By'
                }
            ],
            initialLoad: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            disbursement: {
                employee: null,
                slip_data: null
            }
        };
    },

    computed: {
        ...mapState({
            items: state => state.payroll.my_payroll_slip,
            count: state => state.payroll.my_payroll_slip_count,
            bank_details: state => state.payroll.bank_details,
            payrollLoading: state => state.payroll.payrollLoading,
            payrollError: state => state.payroll.payrollError
        })
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/payroll/payroll-slip',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    },
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("payroll/fetchMyPayrollSlipList", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/payroll/payroll-slip',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    },
                });
                this.perPage = newperPage
                this.$store.dispatch("payroll/fetchMyPayrollSlipList", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("payroll/fetchMyPayrollSlipList", {
                    perPage: this.perPage,
                    currentPage: 1,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },
    },

    methods: {
        fetchInitial() {
            this.$store.dispatch("payroll/fetchMyPayrollSlipList", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        getDate(date) {
            return moment(String(moment(date))).format('MMMM Do YYYY, h:mm:ss a')
        },

        getMonthName(month) {
            const monthIndex = Number(month);
            const monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];
            return monthNames[monthIndex - 1] || month;
        },

        viewDisburse(item) {
            this.disbursement.employee = item ?.employee || null;
            this.disbursement.slip_data = item ?.slip_data || null;
        }
    }
};
</script>

<style scoped>
.form-inside-container {
    display: flex;
    gap: 20px;
    width: 100%;
}

.header-width {
    width: 50%;
}

.item-padding {
    padding-left: 12px;
    padding-right: 12px;
}

.button-style {
    padding: 2px;
    width: 32px;
    font-size: larger;
    text-align: center;
    color: white;
    background-color: #222131;
    border-radius: 4px;
    cursor: pointer;
}

.payroll-modal .modal-content {
    border: 0;
    border-radius: 16px;
    overflow: hidden;
    background: #f8fafc;
}

.payroll-modal .modal-header {
    border-bottom: 1px solid #edf2f7;
    background: #fff;
    padding: 1rem 1.5rem;
}

.payroll-modal .modal-title {
    font-weight: 600;
    font-size: 18px;
}

.payroll-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 100%;
}

.payroll-card-header {
    background: #fff !important;
    font-weight: 600;
    color: #334155;
    padding: 24px 24px 0px 24px;
}

.payroll-card-body {
    background: #fff;
}

.payroll-info-item {
    margin-bottom: 12px;
}

.payroll-label {
    display: block;
    color: #64748b;
    font-size: 12px;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: .5px;
}

.payroll-value {
    display: block;
    color: #1e293b;
    font-size: 15px;
    font-weight: 500;
}

.payroll-table {
    margin-bottom: 0;
}

.payroll-table thead th {
    background: #f8fafc;
    border-top: none;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
}

.payroll-table tbody td {
    vertical-align: middle;
}

.payroll-summary {
    border-radius: 14px;
    padding: 24px;
    text-align: center;
    color: #fff;
}

.payroll-summary small {
    display: block;
    font-size: 13px;
    margin-bottom: 8px;
    opacity: .9;
}

.payroll-summary h3 {
    margin: 0;
    font-weight: 700;
}

.payroll-gross {
    background: linear-gradient(135deg, #4f46e5, #6366f1);
}

.payroll-net {
    background: linear-gradient(135deg, #059669, #10b981);
}

.payroll-status {
    background: linear-gradient(135deg, #d97706, #f59e0b);
}

.payroll-card:hover {
    transform: translateY(-2px);
    transition: all .3s ease;
}

@media screen and (max-width: 991px) {
    .form-inside-container {
        display: flex;
        flex-direction: column;
        gap: 0px;
    }

    .header-width {
        width: 100%;
    }

    .item-padding {
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>
